import { render, staticRenderFns } from "./question-family.vue?vue&type=template&id=54398a6d"
import script from "./question-family.vue?vue&type=script&lang=js"
export * from "./question-family.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports